const resolveUserUnit = defaultOpt => {
  if (typeof defaultOpt !== "object") return ""
  const defaultOption = {
    grade: {},
    area: {},
    school: {},
    company: {}
  }
  const newOption = Object.assign(defaultOption, defaultOpt)
  return newOption.school.schoolName || newOption.company.companyName || ""
}

export default resolveUserUnit
